import React from 'react';

export function LinkedInIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M4.58667 3C3.71037 3 3 3.71037 3 4.58667C3 5.46296 3.71037 6.17333 4.58667 6.17333C5.46296 6.17333 6.17333 5.46296 6.17333 4.58667C6.17333 3.71037 5.46296 3 4.58667 3Z"
        fill="#5371AC"
      />
      <path
        d="M3.09333 7.48C3.04179 7.48 3 7.52179 3 7.57333V17.28C3 17.3315 3.04179 17.3733 3.09333 17.3733H6.08C6.13155 17.3733 6.17333 17.3315 6.17333 17.28V7.57333C6.17333 7.52179 6.13155 7.48 6.08 7.48H3.09333Z"
        fill="#5371AC"
      />
      <path
        d="M7.94667 7.48C7.89512 7.48 7.85333 7.52179 7.85333 7.57333V17.28C7.85333 17.3315 7.89512 17.3733 7.94667 17.3733H10.9333C10.9849 17.3733 11.0267 17.3315 11.0267 17.28V12.0533C11.0267 11.682 11.1742 11.3259 11.4367 11.0634C11.6993 10.8008 12.0554 10.6533 12.4267 10.6533C12.798 10.6533 13.1541 10.8008 13.4166 11.0634C13.6792 11.3259 13.8267 11.682 13.8267 12.0533V17.28C13.8267 17.3315 13.8685 17.3733 13.92 17.3733H16.9067C16.9582 17.3733 17 17.3315 17 17.28V10.8439C17 9.03195 15.4241 7.6144 13.6212 7.77829C13.0652 7.82884 12.5155 7.96706 12.0022 8.18705L11.0267 8.60512V7.57333C11.0267 7.52179 10.9849 7.48 10.9333 7.48H7.94667Z"
        fill="#5371AC"
      />
    </svg>
  );
}
